export const personaCheckboxSelectMessageLabel = "SOb";
export const personaCheckboxSelectConversationLabel = "TOb";
export default {personaCheckboxSelectMessageLabel,personaCheckboxSelectConversationLabel};